<template>
  <div class="newsletter">
    <h2 class="title-font" v-html="title"></h2>
    <custom-form v-if="content" :content="content" />
  </div>
</template>

<script>
import axios from "axios";
import api from "@/api";
import CustomForm from "./CustomForm.vue";
export default {
  components: { CustomForm },
  props: {
    title: null,
  },
  data() {
    return {
      content: null,
    };
  },
  created() {
    this.fetchData();
    
  },
  methods: {
    async fetchData() {
      const res = await api.get(
        `cdn/stories/${this.$i18n.locale}/settings`)
      this.content = res.data.story.content;
    },
  },
};
</script>

<style lang="scss">

@media screen and(max-width:$tablet) {
  .newsletter {
    width: 100%;
    padding:0 15px !important;
  }
  form {
    max-width: 75% !important;
  }
}
.newsletter {
  //background: $primary;
  h2 {
    text-align: center;
    color: #fff;
    padding: 50px 0;
  }
}
</style>
